import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//

import { mapState, mapGetters } from "vuex";
import classic from "./classic/index.vue";
import functional from "./functional/index.vue";
import plain from "./plain/index.vue";
import blend from "./blend/index.vue";
export default {
  name: 'Layout',
  components: {
    classic: classic,
    functional: functional,
    plain: plain,
    blend: blend
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    layoutType: function layoutType(state) {
      return state.settings.layoutType;
    }
  })), mapGetters(['userInfo'])),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.userInfo.prevLogin == 1 && from.path == '/login') {
        //右下角提示上次登录信息
        vm.openNotify();
      }
    });
  },
  methods: {
    openNotify: function openNotify() {
      this.$notify({
        title: '上次登录信息',
        dangerouslyUseHTMLString: true,
        duration: 2000,
        position: 'bottom-right',
        message: "<div style='padding: 10px 0 0 ;'>\n        <p>\u65F6\u95F4\uFF1A ".concat(this.weforsys.toDate(this.userInfo.prevLoginTime), " </p>\n        <p>\u5730\u70B9\uFF1A ").concat(this.userInfo.prevLoginIPAddressName || '', " </p>\n        <p>IP\uFF1A ").concat(this.userInfo.prevLoginIPAddress || '', "  </p></div>\n        ")
      });
    }
  }
};